/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BeneficialOwner } from './beneficial-owner';

export interface BankIDCompanyCheck {
  readonly aml_report_url: string;
  readonly certificate_of_incorporation_url: string;
  readonly beneficial_owners: Array<BeneficialOwner>;
}
